// extracted by mini-css-extract-plugin
export default {"group":"components-settings-currency-conversion-currency-picker-group-module__group"};